import MicroModal from 'micromodal';

declare global {
	interface Window {
		YT: unknown;
		onYouTubeIframeAPIReady?: () => void;
	}
}

namespace NKU.Video {
	const youtubePlayers = new Map<string, YT.Player>();

	const initYouTubePlayer = (videoId: string, uniqueId: string) => {
		// Create a new YouTube player
		const player = new YT.Player(`youtube-player-${uniqueId}`, {
            videoId,
            playerVars: {
                autoplay: 1,
                controls: 1,
                rel: 0,
                showinfo: 0,
            },
        });
        youtubePlayers.set(uniqueId, player);
	};

	const destroyYouTubePlayer = (uniqueId: string) => {
		const player = youtubePlayers.get(uniqueId); 
        if (player) {
            player.destroy();
            youtubePlayers.delete(uniqueId);
        }
	};

	const initVideo = (video: HTMLElement) => {
		video.addEventListener('click', (event: MouseEvent) => {
			event.preventDefault();

			// Get the data attributes from the clicked element
			const modalId = video.getAttribute('data-id');
			const youtubeId = video.getAttribute('data-youtubeid');

			// Extract the unique ID from the modal ID
			const uniqueId = modalId?.replace('modal-', '');

			// Show the Micromodal with the specified ID
			MicroModal.show(modalId, {
				onClose: () => {
					destroyYouTubePlayer(uniqueId);
				},
			});
			// Destroy the YouTube player if it exists

			// Initialize the YouTube player for the clicked video
			initYouTubePlayer(youtubeId, uniqueId);
		});
	};

	export const init = () => {
		setupVideoModule();
	};

	const setupVideoModule = () => {
		let tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

		const videos = document.querySelectorAll('.js-video-modal');
		videos.forEach(initVideo);

		MicroModal.init();

		// Manually handle the modal close event
		document.addEventListener('micromodal:beforeClose', (event: Event) => {
			const modalId = (event.target as HTMLElement).id;
			const uniqueId = modalId.replace('modal-', '');

			// Destroy the YouTube player when the modal is closed
			destroyYouTubePlayer(uniqueId);
		});
	};
}

document.addEventListener('DOMContentLoaded', () => {
	NKU.Video.init();
});
